import React from 'react';

import Stepper from '../../../components/common/stepper';
import Wizard from '../../ClientContainer/ClientCreationContainer/wizard';

const WorkshopWizard = ({ title, steps, activeStep }) => {
  return (
    <Wizard title={title}>
      <div className="wizard__content">
        <div className="wizard__steps-container wizard-padding">
          {steps.map((currentStep, index) => (
            <Stepper
              text={currentStep.title}
              key={index}
              isActive={index === activeStep}
              isDone={index < activeStep}
            />
          ))}
        </div>

        {steps.map((currentStep, index) => {
          return (
            index === activeStep && (
              <React.Fragment key={`showing-step-${index}`}>
                {currentStep.render()}
              </React.Fragment>
            )
          );
        })}
      </div>
    </Wizard>
  );
};

export default WorkshopWizard;
